<script>
import { ArrowUpIcon, HeartIcon, EyeIcon, ShoppingCartIcon } from "vue-feather-icons";
// import { Carousel, Slide } from "vue-carousel";
// import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Navbar from "@/view/front/components/navbar";
import Footer from "@/view/front/components/footer";
import API from "@/core/api";
import IndexService from "@/MainServices/IndexService.js";
// import Multiselect from "vue-multiselect";
// import Skeleton from "@/view/front/components/skeleton";
// import Button from "../../pages/vue-bootstrap/Button.vue";
import { mapGetters, mapState } from "vuex";
import AdmissionForm from "@/MainServices/AdmissionForm.js";
// import CourseFilter from "@/view/front/components/course_filter";
import Swal from "sweetalert2";

/**
 * Shop-product-detail component
 */
export default {
  data() {
    return {
      countval: 1,
      api: API.API_HOME,
      country: this.$route.params.country,
      city: this.$route.params.city,
      uni_name: this.$route.params.uni_name,
      level: this.$route.params.level,
      slug: this.$route.params.slug,
      uni_id: this.$route.params.uni_id,
      id: this.$route.params.id,
      form_id: this.$route.params.form_id,
      course_details: [],
      loading: true,
      showAdmissionForm: false,
      formData: [],
      cities: [],
      selected_cities: [],
      fname: "",
      lname: "",
      email: "",
      subject: "",
      message: "",
      sendToEmail: "",
      course: "",
    };
  },
  components: {
    Navbar,
    // Multiselect,
    Footer,
    // Carousel,
    // Slide,
    ArrowUpIcon,
    // VueSlickCarousel,
    // HeartIcon,
    // EyeIcon,
    // ShoppingCartIcon,
    // Skeleton,
    // CourseFilter, 
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.src = "/images/uni_demo_profile.png";
    },
    increment() {
      this.countval++;
    },
    submit() {
        this.sendToEmail = "umer.isetech@gmail.com";
        IndexService.contactMyUni(this.fname, this.lname, this.email, this.subject, this.message, this.sendToEmail).then((res)=> {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        }).catch((error) => {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    decrement() {
      this.countval--;
    },
    show_admission_form() {
      if (this.currentUser && this.currentUser.role == "student") {
        this.showAdmissionForm = true;
      } else {
        this.$notify({
          group: "foo",
          type: "error",
          duration: 100000,
          title: "Important message",
          text: "Please Login Into Your Student Account For Apply in this course!",
        });
      }
    },
    cancel_admission_form() {
      this.showAdmissionForm = false;
    },
    submit_admission_form() {
      let data = [];
      this.formData.map((el) => {
        el.fields.map((el2) => {
          data.push({ id: el2.id, value: el2.value, label: el2.label });
        });
      });
      let form_data = {
        user_id: this.currentUser.id,
        listing_id: this.course_details.id,
        tamplate_id: this.course_details.form_id,
        values: JSON.stringify(data),
      };
      AdmissionForm.submitApplicationForm(form_data)
        .then((res) => {
          this.showAdmissionForm = false;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 100000,
            title: "Important message",
            text:
              "Your application has been submited, you may check the status in your dashboard!",
          });
        })
        .catch((error) => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 100000,
            title: "Important message",
            text: "Something Went Wrong, Please try latter!",
          });
        });
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  mounted() {
    IndexService.getForm(this.form_id)
      .then((res) => {
        // res.data.map((el) => {
        //   this.cities.push({
        //     id: el.id,
        //     value: el.city,
        //   });
        // });
      })
      .catch((e) => {});

    IndexService.getSingleCourse(
      this.country,
      this.city,
      this.uni_name,
      this.level,
      this.slug,
      this.uni_id,
      this.id
    ).then((response) => {
      this.course_details = response.data[0];
      this.sendToEmail = response.data[0].user_email;
      response.data[0].form_tabs.map((tabs) => {
        let store_local = {
          id: tabs.id,
          name: tabs.name,
          sequence: tabs.sequence,
          fields: [],
        };
        tabs.fields.map((field) => {
          if (field.options !== "1") {
            field.storeOptions = [];
            let storeOptionsInArray = field.options.split(",");
            storeOptionsInArray.map((el) => {
              field.storeOptions.push({ value: el, text: el });
            });
          }
          store_local.fields.push({
            id: field.id,
            caption: field.caption,
            sequence: field.sequence,
            tab_id: field.tab_id,
            label: field.label,
            type: field.type,
            length: field.length,
            frontend: field.frontend,
            options: field.storeOptions,
            editable: field.editable,
            value: null,
          });
        });
        this.formData.push(store_local);
      });
      this.loading = false;
    });
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_course_dets_page_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="course-dets-page-top-im-title" style="text-transform: capitalize;"> {{ slug.replace('-', ' ') }} </h4>
                <!-- <p class="course-dets-page-top-im-ptext">Apply Now</p> -->
                
                <div class="page-next"></div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style scoped>
h2.r_uni__course_filter_sec_maindiv1_h2 {
    text-align: center !important;
    font-weight: bold !important;
    font-size: 25px !important;
    color: #1c5aa5 !important;
    text-shadow: 0 0 #1c5aa5;
    margin-bottom: 2rem !important;
}
body section.r_list_dets_page_dd_section{
  margin-top: 1rem !important;
}
</style>
